<template>
  <v-app>
    <router-view />
    <CommonSnackBar :objects.sync="objects" />
    <CommonLoader :loadingMessage="loaderMessage" :showOverlay="showLoader" />
    <ConfirmationDialog ref="confirmationDialog" />
  </v-app>
</template>

<script>
import { bus } from "@/main.js";
import CommonLoader from "@/components/BaseComponents/CommonLoader.vue";
import CommonSnackBar from "@/components/BaseComponents/CommonSnackBar.vue";
import ConfirmationDialog from "@/components/BaseComponents/ConfirmationDialog.vue";

export default {
  components: {
    CommonLoader,
    CommonSnackBar,
    ConfirmationDialog,
  },
  data: () => ({
    objects: [],
    showLoader: false,
    loaderMessage: "Loading..",
  }),
  created() {
    bus.$on("showToastMessage", (options) => {
      this.objects.push(options);
    });
    bus.$on("showLoader", (value, message) => {
      this.loaderMessage = message;
      this.showLoader = value;
    });
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirmationDialog.open;
  },
  beforeDestroy() {
    bus.$off("showToastMessage");
    bus.$off("showLoader");
  },
};
</script>

<style lang="scss">
@import "./assets/scss/global.scss";
</style>
